<template>
<el-drawer title="设计详情单" :visible.sync="visible" size="100%" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="false">
    <div class="main-demand">
        <div class="form-demand">
            <el-form ref="form" :model="ruleForm" label-width="80px">
                <div class="form-header">
                    <div class="form-nav">
                        <el-checkbox-group v-model="selected">
                            <template v-for="(item,index) in tree">
                                <el-checkbox-button v-if="item.id != 1" class="check-item" name="type" :label="item.id+''" :key="index">
                                    <span>{{ item.title }}</span>
                                </el-checkbox-button>
                            </template>
                        </el-checkbox-group>
                    </div>
                    <div class="form-submit">
                        <template v-if="selected.length>0">
                            <el-date-picker class="attr-date mr8" value-format="yyyy-MM-dd" v-model="ruleForm.date" type="date" placeholder="进场时间"></el-date-picker>
                            <el-button type="primary" @click="showDrawerPass(_self, 'previewView', 'getData', [selected,demand,tree,forms,ruleForm.date,type])">预览</el-button>
                        </template>
                        <el-button type="danger" @click="closeDrawer">关闭</el-button>
                    </div>
                </div>

                <!-- 不存在有效审核，编辑状态下 -->
                <div class="selected-list">
                    <template v-for="item in tree">
                        <div class="selected-item" :key="item.id" v-if="selected.includes(item.id+'')">
                            <div class="tree-title">{{item.title}}</div>
                            <template v-if="type=='editors'">
                                <div class="children">
                                    <template v-for="child in item.children">
                                        <!-- v-if="forms['category_'+child.id].length>0" -->
                                        <div class="category-item" :key="child.id" v-if="forms['category_'+child.id].length>0">
                                            <div class="category-title">
                                                {{child.title}}
                                            </div>
                                            <div class="category-rules">
                                                <div class="select-item-list" v-if="forms['category_'+child.id].length>0">
                                                    <div class="hs-table-pro">
                                                        <div class="hs-table-row  hs-table-header">
                                                            <div class="hs-table-col">供应商</div>
                                                            <div class="hs-table-col">产品</div>
                                                            <div class="hs-table-col">价格</div>
                                                            <div class="hs-table-col" v-for="(e,v) in child.rules" :key="v">
                                                                {{e.label}}
                                                            </div>
                                                            <div class="hs-table-col">数量</div>
                                                            <div class="hs-table-col">自定义价格</div>
                                                            <div class="hs-table-col">使用备注</div>
                                                            <div class="hs-table-col">是否作废</div>
                                                            <div class="hs-table-col w80">操作</div>
                                                        </div>
                                                        <div class="hs-table-row" v-for="(row,index) in forms['category_'+child.id]" :key="index+'category'">
                                                            <div class="hs-table-col">
                                                                {{row.supplier ? row.supplier.title : '未分配'}}
                                                            </div>
                                                            <div class="hs-table-col">
                                                                {{row.product ? row.product.title : '未分配'}}
                                                            </div>
                                                            <div class="hs-table-col">
                                                                {{row.product ? row.product.price : '未分配'}}
                                                            </div>
                                                            <template v-for="(e, f) in row">
                                                                <div class="hs-table-col" :key="f" v-if="f!='settle_no'&&f!='invalid' &&f!='invalid_id' &&f!='count'&& f!='settle' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id'">
                                                                    {{former.getRuleLabel(e,f,child.rules)}}
                                                                </div>
                                                            </template>
                                                            <div class="hs-table-col">{{row.count}}</div>
                                                            <div class="hs-table-col">{{row.price}}</div>
                                                            <div class="hs-table-col">{{row.remark}}</div>
                                                            <div class="hs-table-col">
                                                                <template v-if="row.invalid_id=='0'">已作废</template>
                                                                <template v-if="row.invalid_id=='1'"></template>
                                                            </div>
                                                            <div class="hs-table-col w80" v-if="type=='editors'">
                                                                <el-link v-if="!row.settle || row.settle==3" type="warning" class="mr8" @click="showDrawerPass(_self, 'editorView', 'showDialog', [row,item.supplier,child.id])">临时编辑</el-link>
                                                                <el-link v-else>{{getSettleText(row.settle)}}</el-link>
                                                            </div>
                                                            <div class="hs-table-col w80" v-else>
                                                                <el-link type="warning" class="mr8" v-if="row.settle!=2" @click="removeAttr(index,child.id)">删除</el-link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <div class="children">
                                    <template v-for="child in item.children">
                                        <!-- v-if="forms['category_'+child.id].length>0" -->
                                        <div class="category-item" :key="child.id">
                                            <div class="category-title">
                                                {{child.title}}
                                            </div>
                                            <div class="category-rules">
                                                <div class="category-item-form" v-show="type!= 'editors'">
                                                    <el-select v-model="ruleForm['category_'+child.id]['supplier_id']" filterable clearable class="attr-count w100" @change="getValue(child.id,ruleForm['category_'+child.id]['supplier_id'])">
                                                        <el-option v-for="(supplier,sk) in item.supplier" placeholder="请选择供应商" :key="sk" :label="supplier.title+''" :value="supplier.id"></el-option>
                                                    </el-select>
                                                    <template v-if="Object.keys(productList).length>0">
                                                        <el-select v-model="ruleForm['category_'+child.id]['product_id']" filterable clearable class="attr-count w100" @change="getProValue(child.id,ruleForm['category_'+child.id]['product_id'])">
                                                            <el-option v-for="(product,k) in productList['product_'+child.id]" placeholder="请选择产品" :key="k" :label="product.title" :value="product.id"></el-option>
                                                        </el-select>
                                                    </template>
                                                    <el-input class="attr-count" v-if="ruleForm['category_' + child.id]['product_id']" v-model="ruleForm['category_' + child.id]['product']['price']" disabled placeholder=""></el-input>
                                                    <template v-for="(rule, index) in child.rules">
                                                        <el-select class="attr-select" v-if="rule.type == 'select'" v-model="ruleForm['category_'+child.id][rule.field]" :key="index" :placeholder="'请选择'+rule.label" clearable filterable>
                                                            <el-option v-for="(item, index) in former.getCfgItems(rule.content)" :key="index" :label="former.getItemLabel(item)" :value="former.getItemValue(item)"></el-option>
                                                        </el-select>
                                                        <el-input v-if="rule.type == 'text'" class="attr-input" v-model="ruleForm['category_'+child.id][rule.field]" :key="index" :placeholder="'请输入'+rule.label"></el-input>
                                                        <el-input v-if="rule.type == 'number'" class="attr-input" v-model="ruleForm['category_'+child.id][rule.field]" :key="index" :placeholder="'请输入'+rule.label"></el-input>
                                                        <el-date-picker v-if="rule.type == 'date'" class="attr-input" type="date" value-format="yyyy-MM-dd" v-model="ruleForm['category_'+child.id][rule.field]" :key="index" :placeholder="'请输入'+rule.label"></el-date-picker>
                                                        <el-date-picker v-if="rule.type == 'datetime'" class="attr-input" type="datetime" value-format="yyyy-MM-dd HH:mm" v-model="ruleForm['category_'+child.id][rule.field]" :key="index" :placeholder="'请输入'+rule.label"></el-date-picker>
                                                    </template>
                                                    <el-input type="number" v-model="ruleForm['category_'+child.id]['count']" placeholder="数量" class="attr-count">
                                                        <el-button slot="append" v-if="child.unit">{{child.unit}}</el-button>
                                                    </el-input>
                                                    <el-input type="number" v-model="ruleForm['category_'+child.id]['price']" placeholder="自定义价格" class="attr-count w100">
                                                        <el-button slot="append">元</el-button>
                                                    </el-input>
                                                    <el-input type="text" class="attr-remark" autosize :placeholder="child.tip ? child.tip : '请输入备注'" v-model="ruleForm['category_'+child.id]['remark']"></el-input>
                                                    <el-button type="primary" @click="addAttr(child.id,child.rules,ruleForm['category_'+child.id])">添加</el-button>
                                                </div>
                                                <div class="select-item-list" v-if="forms['category_'+child.id].length>0">
                                                    <div class="hs-table-pro">
                                                        <div class="hs-table-row  hs-table-header">
                                                            <div class="hs-table-col">供应商</div>
                                                            <div class="hs-table-col">产品</div>
                                                            <div class="hs-table-col">价格</div>
                                                            <div class="hs-table-col" v-for="(e,v) in child.rules" :key="v">
                                                                {{e.label}}
                                                            </div>
                                                            <div class="hs-table-col">数量</div>
                                                            <div class="hs-table-col">自定义价格</div>
                                                            <div class="hs-table-col">使用备注</div>
                                                            <div class="hs-table-col">是否作废</div>
                                                            <div class="hs-table-col w80">操作</div>
                                                        </div>
                                                        <div class="hs-table-row" v-for="(row,index) in forms['category_'+child.id]" :key="index+'category'">
                                                            <div class="hs-table-col">
                                                                {{row.supplier ? row.supplier.title : '未分配'}}
                                                            </div>
                                                            <div class="hs-table-col">
                                                                {{row.product ? row.product.title : '未分配'}}
                                                            </div>
                                                            <div class="hs-table-col">
                                                                {{row.product ? row.product.price : '未分配'}}
                                                            </div>
                                                            <template v-for="(e, f) in row">
                                                                <div class="hs-table-col" :key="f" v-if="f!='settle_no'&&f!='invalid' &&f!='invalid_id' &&f!='count'&& f!='settle' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id'">
                                                                    {{former.getRuleLabel(e,f,child.rules)}}
                                                                </div>
                                                            </template>
                                                            <div class="hs-table-col">{{row.count}}</div>
                                                            <div class="hs-table-col">{{row.price}}</div>
                                                            <div class="hs-table-col">{{row.remark}}</div>
                                                            <div class="hs-table-col">
                                                                <template v-if="row.invalid_id=='0'">已作废</template>
                                                                <template v-if="row.invalid_id=='1'"></template>
                                                            </div>
                                                            <div class="hs-table-col w80" v-if="type=='editors'">
                                                                <el-link v-if="!row.settle || row.settle==3" type="warning" class="mr8" @click="showDrawerPass(_self, 'editorView', 'showDialog', [row,item.supplier,child.id])">临时编辑</el-link>
                                                                <el-link v-else>{{getSettleText(row.settle)}}</el-link>
                                                            </div>
                                                            <div class="hs-table-col w80" v-else>
                                                                <el-link type="warning" class="mr8" v-if="row.settle!=2" @click="removeAttr(index,child.id)">删除</el-link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>

            </el-form>
        </div>
        <preview-view ref="previewView" :parent="_self" :orderType="orderType"></preview-view>
        <editor-view ref="editorView" :parent="_self"></editor-view>
    </div>
</el-drawer>
</template>

<script>
const ruleForm = {
    count: '',
    date: ''
};

import {
    showDrawerPass,
    inArray
} from '@/utils/common.js';
import commentView from '@/components/comment/comment.vue';

import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
import previewView from '../demand/preview.vue';
// import editorsView from '../demand/editors.vue';
import editorView from '@/components/editor/editor.vue';
export default {
    components: {
        commentView,
        previewView,
        editorView
    },
    props: {
        parent: {}
    },
    data() {
        return {
            visible: false,
            id: '',
            order_id: '',
            ruleForm: Object.assign({}, ruleForm),
            category: [],
            categoryType: [],
            parent_id: 0,
            tree: [],
            selected: [],
            forms: {},
            module: 'wedding_design',
            module_id: 0,
            demand: {},
            orderType: '',
            productList: {},
            type: ""
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
        this.getRuleTag = weddingUtils.getRuleTag;
        this.inArray = inArray;
    },
    methods: {
        getSettleText(status) {
            if (status == 1) return "结算中";
            if (status == 2) return "结算通过";
            if (status == 3) return "结算驳回";
            return "待结算";
        },
        showDrawer(options, type, orderType) {
            let _this = this;
            this.order_id = options.order_id;
            this.demand = options;
            this.orderType = orderType;
            this.type = type;
            if (type == 'add') {
                let url = '/api/wedding.demand/get';
                this.$post(url, {
                    order_id: _this.order_id,
                    parent_id: options.id,
                    type: "project",
                    type1: "design"
                }).then(function (res) {
                    let resData = res.data;
                    _this.selected = [];
                    _this.tree = resData.tree;
                    _this.tree.forEach(ele => {
                        if (ele.children) {
                            ele.children.forEach(e => {
                                let field = "category_" + e.id;
                                // _this.ruleForm[id] = '';
                                _this.$set(_this.ruleForm, field, {});
                                _this.forms[field] = [];
                            })
                        }
                    })
                    _this.visible = true;
                });
            }
            if (type == 'edit') {
                let url = '/api/wedding.demand/get';
                this.$post(url, {
                    order_id: _this.order_id,
                    parent_id: options.parent_id,
                    id: options.id,
                    type: "project",
                    type1: "design"
                }).then(function (res) {
                    let resData = res.data;
                    _this.module_id = resData.demand.id;
                    _this.selected = resData.demand.category_parent_ids1;
                    let addons = resData.demand.addons1;
                    _this.forms = addons;
                    _this.tree = resData.tree;
                    _this.tree.forEach(ele => {
                        if (ele.children) {
                            ele.children.forEach(e => {
                                let field = "category_" + e.id;
                                if (addons[field] != undefined) {
                                    _this.$set(_this.ruleForm, field, {});
                                    _this.forms[field] = addons[field];
                                } else {
                                    _this.$set(_this.ruleForm, field, {});
                                    _this.forms[field] = [];

                                }
                            })
                        }
                    });

                    _this.visible = true;
                });
            }
            if (type == 'editors') {
                let url = '/api/wedding.demand/get';
                this.$post(url, {
                    order_id: _this.order_id,
                    parent_id: options.parent_id,
                    id: options.id,
                    type: "project",
                    type1: "design"
                }).then(function (res) {
                    let resData = res.data;
                    _this.module_id = resData.demand.id;
                    _this.selected = resData.demand.category_parent_ids1;
                    let addons = resData.demand.addons1;
                    _this.forms = addons;
                    _this.tree = resData.tree;
                    _this.tree.forEach(ele => {
                        if (ele.children) {
                            ele.children.forEach(e => {
                                let field = "category_" + e.id;
                                if (addons[field] != undefined) {
                                    _this.$set(_this.ruleForm, field, {});
                                    _this.forms[field] = addons[field];
                                } else {
                                    _this.$set(_this.ruleForm, field, {});
                                    _this.forms[field] = [];

                                }
                            })
                        }
                    });

                    _this.visible = true;
                });
            }

        },
        getValue(id, supplier_id) {
            let _this = this;
            let url = '/api/supplier.product/group';
            this.$post(url, {
                supplier_id: supplier_id,
                category_id: id

            }).then(res => {
                let attrId = "product_" + id;
                _this.$set(_this.productList, attrId, res.data.list) //在没有对象情况下下_this.productList[list] = res.data.list
                let list = _this.tree[0].supplier;
                list.map(item => {
                    if (item.id == supplier_id) {
                        _this.ruleForm['category_' + id]["supplier"] = item;
                    }
                })
            })
        },
        getProValue(id, product_id) {
            let _this = this;
            let attrId = "product_" + id;
            let list = this.productList[attrId];
            list.map(item => {
                if (item.id == product_id) {
                    _this.ruleForm['category_' + id]["product"] = item;
                }
            })
        },
        addAttr(id, rules, addrules) {
            let _this = this;
            let field = "category_" + id;
            if (_this.productList['product_' + id] == 0 || !addrules.product_id) {
                this.$message({
                    type: "danger",
                    message: "请录入要选择的产品"
                });
                return false;
            }
            if (!addrules.count) {
                this.$message({
                    type: "danger",
                    message: "请录入数量"
                });
                return false;
            }
            let row = Object.assign({}, this.ruleForm[field]);
            if (Object.keys(row).length == 0) {
                this.$message({
                    type: "danger",
                    message: "请录入要选择的数据"
                });
                return false;
            }

            let isEmpty = false;
            for (let i in row) {
                if (i != 'remark' && i != 'price' && !row[i]) {
                    isEmpty = true;
                }
            }

            if (isEmpty) {
                this.$message({
                    type: "danger",
                    message: "请录入要选择的数据"
                });
                return false;
            }

            this.forms[field].push(row);
            this.$forceUpdate();
        },
        closeDrawer() {
            this.visible = false;
        },
        //删除
        removeAttr(index, id) {
            this.$confirm('确定删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.forms['category_' + id].splice(index, 1);
                this.$forceUpdate();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        invalid(row) {
            let invalid = {
                "status": 1,
                'title': '已作废'
            }
            invalid = Object.assign({}, invalid);
            row.invalid = invalid;
            this.$forceUpdate();
        },
        submit() {
            let _this = this;
            let url = '/api/project.project/create';
            let params = {};
            params.order_id = _this.order_id;
            params.category_parent_ids = _this.selected;
            params.use_date = _this.ruleForm.date;
            params.addons = _this.forms;
            this.$post(url, params).then(res => {
                if (res.code == '200') {
                    _this.visible = false;
                    _this.$message({
                        type: 'success',
                        message: res.msg
                    });
                } else {
                    _this.$message({
                        type: 'danger',
                        message: res.msg
                    });
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 9rem;
                }

                .w100 {
                    width: 10%;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    width: 100%;
    padding: 12px;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;
    height: 100vh;
    overflow: hidden;

    .form-demand {
        flex: 1;
        height: calc(100vh - 58px);
        overflow: auto;
        margin-top: 58px;
        padding-bottom: 30px;
        border-right: 1px solid #dedede;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;

        padding-bottom: 30px;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: .5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: .5px solid #f6f7fb;
        }

        .hs-table-col.w80 {
            flex: 0 120px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}
</style>
